import { jsx as _jsx } from "react/jsx-runtime";
import PageNotFound from 'pages/PageNotFound';
import services from 'services';
import OrderEntitiesList from './List';
var OrderEntitiesPage = function () {
    if (!services.permissionService.hasPermissionToViewOrderEntities()) {
        return _jsx(PageNotFound, {});
    }
    return _jsx(OrderEntitiesList, {});
};
export default OrderEntitiesPage;
